import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

// SERVICES
import { IClientCreditMemo } from '../../../client/interfaces';
import { ClientCreditMemoApiService } from '../../../shared/services/api/client/client-credit-memo-api.service';

// INTERFACES

@Component({
  selector: 'lum-credit-memo-details',
  templateUrl: './credit-memo-details.component.html',
  styleUrls: ['./credit-memo-details.component.scss'],
})
export class CreditMemoDetailsComponent implements OnInit, OnDestroy {
  private onDestroy$ = new Subject();
  businessAccountId :number = 0;
  creditMemoId :number = 0;
  creditMemoDetails :IClientCreditMemo;
  creditMemos$ :Observable<IClientCreditMemo[]>;
  creditMemoLoading$ :Observable<boolean>;
  constructor(
    private route :ActivatedRoute,
    private clientCreditMemoApiService :ClientCreditMemoApiService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    this.getDataFromService();
    this.getRouterParams().subscribe();
  }

  private getDataFromService() :void {
    this.creditMemos$ = this.clientCreditMemoApiService.creditMemos$;
    this.creditMemoLoading$ = this.clientCreditMemoApiService.loading$;
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private getRouterParams() :Observable<Params> {
    return this.route.params.pipe(
      tap((params :Params) => {
        const { businessAccountId, creditMemoId } = params;
        this.clientCreditMemoApiService.get({
          businessAccountId: businessAccountId,
          params: {
            creditMemoId: creditMemoId,
            relations:
              'paymentLogs,paymentLogs.createdByUser,paymentLogs.clientPurchaseOrder,paymentLogs.clientPurchaseOrder.lineItems',
          },
        });
        this.getCreditMemo();
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getCreditMemo() :void {
    this.creditMemos$.pipe(takeUntil(this.onDestroy$)).subscribe((response) => {
      if (response.length > 0) {
        this.creditMemoDetails = response.reduce((resp, item) => item);
        this.cd.detectChanges();
      }
    });
  }
}
